import { useState } from 'react';
import type { Notice } from '@/types';

interface AccordionItemProps {
  notice: Notice;
}

export function AccordionItem({ notice }: AccordionItemProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="border-b border-gray-200">
      <button
        onClick={toggleExpanded}
        className="w-full px-4 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between"
      >
        <div className="flex-1">
          <h3 className="text-lg font-medium text-[#222222] mb-1">
            {notice.title}
          </h3>
          <p className="text-sm text-gray-600">
            {new Date(notice.created_at).toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        </div>
        <div className="ml-4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={`transition-transform duration-200 ${
              isExpanded ? 'transform rotate-180' : ''
            }`}
          >
            <path
              d="M7 10L12 15L17 10"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </button>
      
      {/* Expanded Content */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 py-4 bg-white">
          <div className="prose prose-sm max-w-none">
            <div
              className="text-gray-700 whitespace-pre-wrap leading-relaxed"
              dangerouslySetInnerHTML={{ __html: notice.content }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}